import React from 'react';

import * as StationActions from './actions';
import * as StationConstants from './constants';
import * as D from './deps';
import StationReducer from './reducer';
import StationWatchers from './sagas/watchers';
import * as StationServices from './services';
import * as StationUtils from './utils';

export default D.createDomainModule({
  name: StationConstants.DOMAIN_NAME,
  actions: StationActions,
  utils: StationUtils,
  services: StationServices,
  constants: {},
  selectors: {},
  components: {
    StationNarrative: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_station-narrative" */ './components/StationNarrative/StationNarrative',
            )
          }
        />
      );
    },
    StationsYouMightLike: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_stationsyoumightlike" */ './components/StationsYouMightLike/StationsYouMightLike',
            )
          }
        />
      );
    },
    MyStations: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_mystations" */ './containers/MyStations/MyStations',
            )
          }
        />
      );
    },
    MyStationsCore: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_mystationscore" */ './components/MyStationsCore/MyStationsCore',
            )
          }
        />
      );
    },
    DiscoveryTuner: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_discoverytuner" */ './components/DiscoveryTuner/DiscoveryTuner',
            )
          }
        />
      );
    },
    SignupTracks: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_signuptracks" */ './components/SignupTracks/SignupTracks',
            )
          }
        />
      );
    },
    BackstageCollectedStation: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-collected-station" */ './components/CollectedStation/pages/BackstageCollectedStation',
            )
          }
        />
      );
    },
    BackstageCollectedStationSeeds: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-collected-station-seeds" */ './components/CollectedStation/pages/BackstageCollectedStationSeeds',
            )
          }
        />
      );
    },
    BackstageCollectedStationAllThumbs: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_backstage-collected-station-thumbed-up" */ './components/CollectedStation/pages/BackstageCollectedStationAllThumbs',
            )
          }
        />
      );
    },
    MyStationsEmpty: props => {
      return (
        <D.AsyncComponent
          {...props}
          importer={() =>
            System.import(
              /* webpackChunkName: "c_mystationsempty" */ './components/MyStationsEmpty/MyStationsEmpty',
            )
          }
        />
      );
    },
  },
  reducer: StationReducer,
  persisted: true,
  onLoad() {},
  onStart() {
    this.registeredHandlers = D.registerHandlers(StationWatchers);
  },
  onStop() {
    D.removeAndStopHandlers(this.registeredHandlers, this.name);
  },
});
